// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchBar_root__EGoXc","searchIcon":"SearchBar_searchIcon__3_QYv","searchInput":"SearchBar_searchInput__rfGDG"};